<template>
	<div>
		<div class="bb-header">
			<div class="uk-flex uk-flex-middle uk-justify-sb buttons">
				<button class="exit" uk-toggle="target: #ww-builder-container"><i class="fas fa-times"></i> Exit Builder</button>
				<div class="uk-hidden@m">
					<a href="tel:8669715516" class="button blue">Questions? <br> Call us. <i class="fas fa-phone"></i></a>
				</div>
			</div>
			<div class="uk-flex uk-flex-middle total-menu">
				<div>
					<h3>{{ wallbed.name }}</h3>
				</div>
				<div style="margin-left: auto">
					<div class="checkout-options">
						<div class="uk-flex uk-flex-middle">
							<p v-if="buildTotals && buildTotals.total" class="total">Total: {{ buildTotals.total | currency }}</p>
							<div class="uk-visible@m">
								<a href="#" class="button outline gold" uk-toggle="target:#request-follow">Request Follow-Up</a>
							</div>
							<a v-if="buildTotals && buildTotals.total" href="#" class="button gold" @click.prevent="addToCart">Add to Cart</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		name : "header",
		components: {},
		methods : {
			/**
			 * get all items needed for pricing and send to cart.
			 */
			addToCart(){
				document.getElementById("builder-loader").setAttribute('class','on');
				// build data iobject
				let data = {
					series : this.wallbed.series.name,
					style : this.wallbed.name,
					pricing : this.pricing_items,
					product : this.product.id,
					slug : this.product.slug,
					size : this.selected_size.mattress_size.name,
					wood : (this.selected_wood != null) ? this.selected_wood.name : null,
					finish : (this.selected_finish != null) ? this.selected_finish.name : null,
					headboard : (this.selected_headboard != null) ? this.selected_headboard.name : null ,
					desk_table : (this.selected_desk_table != null) ? this.selected_desk_table.front_panel_type.name : null,
					left_cabinet : null,
					right_cabinet : null,
					mattress : (this.selected_mattress != null) ? this.selected_mattress.name : null,
					options : []
				};

				data.pricing.use_discounts = false;
				if(this.useDiscounts){
					data.pricing.use_discounts = true;
				}

				// handle left cabinet
				if(this.selected_cabinet_left != null){
					data.left_cabinet = {
						name : this.selected_cabinet_left.cabinet_type.name,
						size : this.selected_cabinet_left.width,
						nightstand : this.left_cabinet_night_tray,
						glass_doors : this.left_cabinet_glass_doors,
						glass_shelves : this.left_cabinet_glass_shelves
					};
				}
				// handle right cabinet
				if(this.selected_cabinet_right != null){
					data.right_cabinet = {
						name : this.selected_cabinet_right.cabinet_type.name,
						size : this.selected_cabinet_right.width,
						nightstand : this.right_cabinet_night_tray,
						glass_doors : this.right_cabinet_glass_doors,
						glass_shelves : this.right_cabinet_glass_shelves
					};
				}

				// selected options
				if(this.selected_options.length > 0){
					this.selected_options.forEach(row => {
						data.options.push(row.name);
					});
				}

				let formData = new FormData;
				formData.append('action',"ww_builder_add_to_cart");
				formData.append('nonce',this.wp_nonce);
				formData.append('data',JSON.stringify(data));

				//eslint-disable-next-line
				axios.post(ajax_object.ajax_url,formData)
					.then(response => this.handleAddToCart(response.data))
					//eslint-disable-next-line
				    .catch(error => console.log(error));
			},
			/**
			 * check response
			 * @param  {[type]} response [description]
			 * @return {[type]}          [description]
			 */
			handleAddToCart(response){
				if(response.success == true) window.location.href = "/cart";
			}
		},
		computed : {
			buildTotals() {
				if(this.selected_size == null) return {total : ""};
					
				let pricingItems =  {
					wallbed_price_id : null,
					finish_grade_id : null,
					headboard_id : null,
					desk_table_id : null,
					selected_options: [],
					left_cabinet : {
						price_id : null,
						nightstand : this.left_cabinet_night_tray,
						glass_doors : this.left_cabinet_glass_doors,
						glass_shelves : this.left_cabinet_glass_shelves
					},
					right_cabinet : {
						price_id : null,
						nightstand : this.right_cabinet_night_tray,
						glass_doors : this.right_cabinet_glass_doors,
						glass_shelves : this.right_cabinet_glass_shelves
					},
					mattress_price_id : null
				};



				let totals = {};
				let discounts = [];
				// get base price for size
				let sizePrice = null;
				for(let i in this.selected_size.prices){
					const price = this.selected_size.prices[i];
					// price is dependent on selected wood 
					// check price woods to see if it matches the selected one
					let found = false;
					for(let w in price.woods){
						if(price.woods[w].id == this.selected_wood.id){
							found = true;
							break;
						}
					}
					// found a match?
					if(found){
						sizePrice = price;
						pricingItems.wallbed_price_id = price.id
						break;
					}
				}
				// base price.
				totals.base = parseFloat(sizePrice.price);
				if(this.useDiscounts && sizePrice.discount_amount){
					discounts.push(parseFloat(sizePrice.discount_amount));
				}
				// see if the finish has a wallbed upcharge (because of the type of finish)
				if(this.selected_finish != null){
					
					pricingItems.finish_grade_id = this.selected_finish.grade.id;

					let wallbedUpcharge = this.selected_finish.grade.wallbed_upcharge;
					totals.finish_wallbed_upcharge = (wallbedUpcharge != null) ? parseFloat(wallbedUpcharge) : 0;
				}
				// headboard size
				if(this.selected_headboard != null){
					totals.headboard = parseFloat(this.selected_headboard.price);
					pricingItems.headboard_id = this.selected_headboard.id;
				}

				// desk table option
				if(this.selected_desk_table != null){
					totals.desk_table = parseFloat(this.selected_desk_table.price);
					pricingItems.desk_table_id = this.selected_desk_table.id;
				}

				// selected options
				if(this.selected_options.length > 0){
					let optionsTotal = 0;
					this.selected_options.forEach(row => {
						if(this.wallbed.type == "wallbed" || this.wallbed.type == "sofabed"){
							optionsTotal += parseFloat(row.wallbed_upcharge);
							if(this.useDiscounts && row.discount_amount){
								discounts.push(parseFloat(row.discount_amount));
							}
						} else {
							optionsTotal += parseFloat(row.price);
							if(this.useDiscounts && row.discount_amount){
								discounts.push(parseFloat(row.discount_amount));
							}
						}
						pricingItems.selected_options.push(row.id);
					});
					totals.additional = optionsTotal;
				}

				// see if cabinets need to have an upcharge because of the finish.
				let cabinetUpcharge = 0;
				if(this.selected_finish != null){
					cabinetUpcharge = this.selected_finish.grade.cabinet_upcharge == null ? 0 : parseFloat(this.selected_finish.grade.cabinet_upcharge);
				}

				// left cabinet
				if(this.selected_cabinet_left != null){
					let leftCabinetPrice = null;
					let prices = this.selected_cabinet_left.cabinet_type.prices;
					let lWidth = this.selected_cabinet_left.width;
					for(let p in prices){
						let price = prices[p];
						// match wood to get the write price
						let found = false;
						if(price.width == lWidth){
							for(let w in price.woods){
								if(price.woods[w].id == this.selected_wood.id){
									found = true;
									break;
								}
							}
						}
						// found a match?
						if(found){
							leftCabinetPrice = price;
							pricingItems.left_cabinet.price_id = price.id;
							break;
						}
					}
					totals.left_cabinet = parseFloat(leftCabinetPrice.price) + cabinetUpcharge;

					// additions for left cabinet
					if(this.left_cabinet_night_tray){
						totals.left_night_tray = parseFloat(this.wallbed.nightstand_upcharge);
					}
					if(this.left_cabinet_glass_doors){
						totals.left_glass_door = parseFloat(this.wallbed.glass_door_upcharge);
					}
					if(this.left_cabinet_glass_shelves){
						totals.left_glass_shelf = parseFloat(this.wallbed.glass_shelf_upcharge);
					}
				}

				// right cabinet
				if(this.selected_cabinet_right != null){
					let rightCabinetPrice = null;
					let prices = this.selected_cabinet_right.cabinet_type.prices;
					let rWidth = this.selected_cabinet_right.width;
					for(let p in prices){
						let price = prices[p];
						let found = false;
						// match wood to get the write price
						if(price.width == rWidth){
							for(let w in price.woods){
								if(price.woods[w].id == this.selected_wood.id){
									found = true;
									break;
								}
							}
						}
						// found a match?
						if(found){
							rightCabinetPrice = price;
							pricingItems.right_cabinet.price_id = price.id;
							break;
						}
					}
					totals.right_cabinet = parseFloat(rightCabinetPrice.price) + cabinetUpcharge;

					// additions for right cabinet
					if(this.right_cabinet_night_tray){
						totals.right_night_tray = parseFloat(this.wallbed.nightstand_upcharge);
					}
					if(this.right_cabinet_glass_doors){
						totals.right_glass_door = parseFloat(this.wallbed.glass_door_upcharge);
					}
					if(this.right_cabinet_glass_shelves){
						totals.right_glass_shelf = parseFloat(this.wallbed.glass_shelf_upcharge);
					}
				}

				// mattress
				if(this.selected_mattress != null){
					pricingItems.mattress_price_id = this.selected_mattress.price.id;
					totals.mattress = parseFloat(this.selected_mattress.price.price);
					if(this.useDiscounts && this.selected_mattress.price.discount_amount){
						discounts.push(parseFloat(this.selected_mattress.price.discount_amount));
					}
				}

				// add up all totals.
				let total = 0;
				for(let i in totals){
					total += totals[i];
				}
				totals.originalPrice = total;
				for(let i in discounts){
					total -= discounts[i];
				}
				totals.total = total;
				totals.discounts = discounts;
				this.$store.commit('setTotals',totals);
				this.$store.commit('setPricingItems',pricingItems);
				return totals;
			},
			...mapState({
				wallbed : state => state.wallbed,
				selected_size : state => state.selected_size,
				selected_wood : state => state.selected_wood,
				selected_finish : state => state.selected_finish,
				selected_headboard : state => state.selected_headboard,
				selected_desk_table : state => state.selected_desk_table,
				selected_options : state => state.selected_options,
				selected_cabinet_left : state => state.selected_cabinet_left,
				selected_cabinet_right : state => state.selected_cabinet_right,
				selected_mattress : state => state.selected_mattress,
				product : state => state.product,
				pricing_items : state => state.pricing_items,
				wp_nonce : state => state.wp_nonce,
				right_cabinet_night_tray : state => state.right_cabinet_night_tray,
				right_cabinet_glass_doors : state => state.right_cabinet_glass_doors,
				right_cabinet_glass_shelves : state => state.right_cabinet_glass_shelves,
				left_cabinet_night_tray : state => state.left_cabinet_night_tray,
				left_cabinet_glass_doors : state => state.left_cabinet_glass_doors,
				left_cabinet_glass_shelves : state => state.left_cabinet_glass_shelves,
				useDiscounts : state => state.useDiscounts
			})
		}
	}
</script>